module.exports = __webpack_public_path__ + "img/active-list.6e54c250.svg";